export default __webpack_public_path__ + "static/media/pants.fd7590ce.jpg";